import React, {useContext, useEffect} from 'react'
import {HelpIcon, withTooltip} from '@modifi/ui'
import {useTranslation, formatNumber} from '@modifi/plugin-i18n'
import {
  TRADE_PARTNER_TRADING_CURRENCY,
  TRADE_PARTNER_EXPECTED_FINANCING_LIMIT,
  NumberFormatInputWithInputContainer,
} from '@modifi/plugin-onboarding'

import {FormDataContext} from '@modifi/plugin-forms'
import {Currency, CurrencyVal} from '@modifi/enums'

import {FormInputComponentCol} from '../../../../plugins/onboarding'

type GetConversionRate = (expectedFinancingLimitCurrency: CurrencyVal) => number

type FetchExchangeRateType = () => void

export type ExpectedFinancingLimitType = {
  canUpdateSellerTradePartnerDataInfo: boolean
  getConversionRate: GetConversionRate
  fetchAllExchangeRates: FetchExchangeRateType
}

const TooltipIcon = withTooltip(HelpIcon)

const ExpectedFinancingLimit: React.FC<ExpectedFinancingLimitType> = ({
  canUpdateSellerTradePartnerDataInfo,
  getConversionRate,
  fetchAllExchangeRates,
}) => {
  const {t} = useTranslation('charon')
  const {data} = useContext(FormDataContext)
  const expectedFinancingLimitCurrency = data[TRADE_PARTNER_TRADING_CURRENCY] as
    | CurrencyVal
    | null
    | undefined
  const showConvertedAmount = expectedFinancingLimitCurrency !== Currency.USD
  const expectedFinancingLimitAmount = data[TRADE_PARTNER_EXPECTED_FINANCING_LIMIT] || 0

  const getConvertedAmount = () => {
    const conversionRate = expectedFinancingLimitCurrency
      ? getConversionRate(expectedFinancingLimitCurrency)
      : 1
    const convertedAmount = +expectedFinancingLimitAmount * conversionRate
    return convertedAmount ? `   (${formatNumber(convertedAmount, {currency: Currency.USD})})` : ''
  }

  useEffect(() => {
    fetchAllExchangeRates()
  }, [fetchAllExchangeRates])
  return (
    <FormInputComponentCol
      t={t}
      inputName={TRADE_PARTNER_EXPECTED_FINANCING_LIMIT}
      inputComponent={NumberFormatInputWithInputContainer}
      inputProps={{
        label: (
          <>
            {t('trade-partner.expected-financing-limit.label')}
            {'   '}
            {showConvertedAmount ? (
              <TooltipIcon
                tooltipContent={t('trade-partner.expected-financing-limit.tooltip.text')}
                tooltipTheme="dark"
                tooltipPlacement="right"
              />
            ) : null}
          </>
        ),
        disabled: !canUpdateSellerTradePartnerDataInfo || !expectedFinancingLimitCurrency,
        decimalSeparator: '.',
        decimalScale: 2,
        fixedDecimalScale: true,
        thousandSeparator: true,
        prefix: `${expectedFinancingLimitCurrency || ''}  `,
        required: true,
        suffix: `${showConvertedAmount ? getConvertedAmount() : ''}`,
        allowNegative: false,
      }}
      colProps={{md: 8}}
    />
  )
}

export default ExpectedFinancingLimit
